// extracted by mini-css-extract-plugin
export var active = "styles-module--active--078e6";
export var advisors = "styles-module--advisors--89506";
export var advisorsContainer = "styles-module--advisorsContainer--4259c";
export var backButton = "styles-module--backButton--f2845";
export var backButtonIcon = "styles-module--backButtonIcon--54610";
export var buttonContainer = "styles-module--buttonContainer--0d362";
export var container = "styles-module--container--d1fa6";
export var noAdvisors = "styles-module--noAdvisors--c8439";